export default {
  check_status: {
    verified: 'Verificado',
    pending: 'Pendente',
    failed: 'Falhou',
    not_applicable: 'Não necessário',
    required: 'Obrigatório',
  },
  records: {
    type: 'Tipo',
    name: 'Nome',
    value: 'Valor',
    status: 'Estado',
    certificate: 'Certificado',
    certificate_hint: 'Emitido automaticamente assim que os registos acima forem encontrados.',
    full_name: 'Nome completo:',
  },
  check_hint: {
    found: 'Foi encontrado {{values}} em vez disso. Substitua-o pelo valor indicado.',
    missing: 'Este registo não foi encontrado.',
    certificate: 'Não foi possível emitir o certificado. Corrija os registos assinalados acima e verifique novamente.',
    certificate_unknown:
      'Não foi possível emitir o certificado. Verifique novamente mais tarde e contacte o suporte se continuar assim.',
    regressed: 'Este registo já tinha sido verificado e deixou de ser encontrado.',
    technical: 'Detalhe técnico: {{error}}',
    held_by_another_project:
      '{{name}} é usado por outro site na Vercel, por isso não consegue encaminhar os visitantes para a loja em www.{{name}}. Para que {{name}} também abra a loja, remova primeiro o domínio desse outro site.',
    certificate_pending: {
      not_attached: 'Em curso: estamos a adicionar o domínio do nosso lado.',
      awaiting_dns: 'Em curso: o certificado é emitido assim que os registos acima forem encontrados.',
      awaiting_certificate:
        'Em curso: os registos apontam para nós e o certificado está a ser emitido. Normalmente demora alguns minutos.',
    },
    certificate_failed: {
      ownership_proof_required:
        '{{name}} também está ligado a outra conta Vercel. Para provar que lhe pertence, adicione também os registos TXT abaixo no fornecedor de DNS e verifique novamente.',
      held_by_another_project:
        'Outro site na Vercel já usa {{name}}. Remova primeiro o domínio desse site e verifique novamente — ou use outro domínio.',
      dns_correct_but_unconfigured:
        'Os registos acima estão corretos, mas outra coisa em {{name}} bloqueia o certificado. Remova qualquer registo AAAA nesse nome, desative qualquer proxy à frente dele (como a nuvem laranja no Cloudflare) e certifique-se de que nenhum registo CAA exclui a Let’s Encrypt. Depois, verifique novamente.',
      name_mismatch:
        '{{name}} responde com um certificado para {{names}}. Certifique-se de que os registos acima são os únicos em {{name}}; se forem, contacte o suporte.',
      name_mismatch_unnamed:
        '{{name}} responde com um certificado para outro nome. Certifique-se de que os registos acima são os únicos em {{name}}; se forem, contacte o suporte.',
      expired:
        'O certificado expirou e não foi renovado. Fomos alertados e estamos a tratar do assunto — por agora não é preciso fazer nada.',
      expiring:
        'O certificado expira em breve e ainda não foi renovado. Estamos a tratar do assunto — por agora não é preciso fazer nada.',
      attach_refused:
        'O nosso fornecedor de alojamento recusou adicionar {{name}} do nosso lado. Fomos alertados e estamos a analisar — por agora não é preciso alterar nada no fornecedor de DNS.',
    },
    certificate_overdue: {
      not_attached: 'Após 48 horas, ainda não foi possível adicionar o domínio do nosso lado. Contacte o suporte.',
      awaiting_dns:
        'Ainda à espera dos registos acima após 48 horas. Corrija os registos assinalados acima e verifique novamente.',
      awaiting_dns_records_verified:
        'Ainda não emitido após 48 horas, embora os registos acima estejam verificados. Contacte o suporte.',
      awaiting_certificate:
        'Os registos apontam para nós, mas o certificado ainda não foi emitido após 48 horas. Contacte o suporte.',
    },
    certificate_dates: {
      valid_until: 'Válido até {{date}}.',
      expires_on: 'Expira a {{date}}.',
      expired_on: 'Expirou a {{date}}.',
    },
  },
};
